import { Box, CircularProgress, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

/**
 * Skeleton loader that mirrors the transcription table UI: card with header (Speaker Label | Texto)
 * and content rows with narrow speaker cell and variable-length text cell.
 */
export function TranscriptionLoading() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        mt: 10,
        gap: 1,
      }}
    >
      <CircularProgress size={16} />
      <Typography variant="body2" color="text.secondary">
        <FormattedMessage
          id="audit.diarization.processing"
          defaultMessage="Procesando transcripción"
        />
      </Typography>
    </Box>
  );
}
